<template>
  <article class="news-card">
    <div class="news-image-wrap">
      <img :src="coverUrl" class="news-img" alt="news-image" />
    </div>
    <div class="news-description">
      <div>
        <div class="news-date">{{ formatDate(item?.published_at || item?.date) }}</div>
        <div class="render-title">{{ title }}</div>
      </div>
      <div class="open-news">
        <RouterLink class="read-more btn btn-outline-success" :to="`/feed/${item?.id}`">
          {{ t('readMore') }}
        </RouterLink>
      </div>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import emptyNewsImage from '@/assets/feed/imgNewsEmpty.svg';

const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});

const { t } = useI18n();
const locale = computed(() => (localStorage.getItem('translation') === 'kz' ? 'kk' : 'ru'));

function parseMaybeJson(value, fallback = {}) {
  if (!value) return fallback;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

const title = computed(() => {
  const titleByLang = parseMaybeJson(props.item?.title_by_lang, {});
  return titleByLang[locale.value] || props.item?.caption || '';
});

const coverUrl = computed(() => {
  const cover = parseMaybeJson(props.item?.cover_by_langs, {});
  return cover[locale.value] || props.item?.image || emptyNewsImage;
});

function formatDate(date) {
  if (!date) return '';
  try {
    return new Intl.DateTimeFormat(locale.value === 'kk' ? 'kk-KZ' : 'ru-RU', {
      day: 'numeric',
      month: 'long'
    }).format(new Date(date));
  } catch {
    return '';
  }
}
</script>

<style scoped>
.news-card {
  width: 300px;
  height: 430px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.news-image-wrap {
  height: 257px;
  width: 100%;
}

.news-img {
  width: 100%;
  height: 257px;
  object-fit: cover;
}

.news-description {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 16px;
}

.news-date {
  font-size: 14px;
  color: #6c757d;
}

.render-title {
  margin: 8px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #263238;
  height: 56px;
  overflow: hidden;
}

.open-news {
  display: flex;
  justify-content: flex-start;
}

.read-more {
  font-size: 16px;
}

@media (max-width: 768px) {
  .news-card {
    width: 100%;
    height: auto;
  }
}
</style>
